import { useState, useLayoutEffect, useRef, Fragment } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

function StepScroll({
  data,
  step = 2,
  render,
  styles,
  Indicator,
  gutter,
  elementWidth,
}) {
  let refs = [];

  const container = useRef(null);
  const [left, setLeft] = useState(0);
  const [right, setRight] = useState(0);

  const updateBounding = () => {
    const {
      left: leftBound,
      right: rightBound,
    } = container.current.getBoundingClientRect();

    let lefted = false;
    let righted = false;

    for (let i = 0; i < data.length; i++) {
      const { left: itemLeft, right: itemRight } = refs[
        i
      ].getBoundingClientRect();
      if (!lefted && itemLeft > leftBound) {
        setLeft(i - 1 >= 0 ? i - 1 : 0);
        lefted = true;
      }

      if (itemRight >= rightBound) {
        setRight(i);
        righted = true;
        break;
      }
    }

    !righted && setRight(data.length - 1);
  };

  useLayoutEffect(() => {
    updateBounding();
  }, []);

  const handleScrollRight = () => {
    updateBounding();

    const index = right + step >= data.length ? data.length - 1 : right + step;
    scrollToItem(refs[index]);
  };

  const handleScrollLeft = () => {
    updateBounding();
    const index = left - step >= 0 ? left - step : 0;
    scrollToItem(refs[index]);
  };

  const scrollToItem = (item) => {
    disableBodyScroll(document.body);
    item.scrollIntoView({
      behaviour: "smooth",
      block: "nearest",
      inline: "nearest",
    });
    enableBodyScroll(document.body);
  };

  return (
    <Fragment>
      {Indicator && (
        <Indicator
          scrollLeft={handleScrollLeft}
          scrollRight={handleScrollRight}
          isLeft={left === 0}
          isRight={right === data.length - 1}
        />
      )}
      <div
        css={{
          display: "flex",
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          alignItems: "stretch",
          ...styles,
        }}
      >
        <div
          ref={container}
          onScroll={updateBounding}
          css={{
            overflowX: "scroll",
            overflowY: "visible",
            scrollBehavior: "smooth",
            msOverflowStyle: "none",
            scrollbarWidth: 0,
            padding: "4px 0",

            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <ul css={{ display: "flex", padding: "8px 0", margin: 0 }}>
            {data.map((e, i) => (
              <div
                ref={(ref) => (refs[i] = ref)}
                key={e._id || i}
                css={{
                  paddingRight: gutter,
                  minWidth: elementWidth,
                }}
              >
                {render ? render(e) : e}
              </div>
            ))}
          </ul>
        </div>
      </div>
    </Fragment>
  );
}

export default StepScroll;
